import {ParentController, StaticFieldComponent} from "../../DynamicFormTypes.ts";

export const isFalsy = (value: string | null | undefined) => {
    return value == "null" || value == null || value == undefined || value == "" || value == " ";
}

export const determineExternalWatch = (component: StaticFieldComponent, shouldIRegister: boolean): string | undefined => {

    if (!component.watchFieldKey) {
        //no watch field key, no need to watch! Also if dumb, no need to watch
        return undefined;
    }
    if (!shouldIRegister) {
        console.error("StaticField cannot both not register with form and watch an external field");
        return undefined;
    }
    const lastIndex = component.fieldKey.lastIndexOf('.')
    if (lastIndex != -1) {
        //adjust for nested fields (Fields inside datagrid need to watch the key in the same datagrid by default)
        //todo may have to figure out a way for it to watch any key (even not in the same datagrid)
        //but it would seem weird to have a field in a datagrid that watches a field outside of it
        //because then all the rows would have the same field
        return component.fieldKey.substring(0, lastIndex + 1) + component.watchFieldKey;
    }
    return component.watchFieldKey;
}

export interface StaticFieldDisplayProps {
    component: StaticFieldComponent;
    value: any;
    controller: ParentController
}